import { connect } from "react-redux";
import LandingPage from "../components/LandingPage";
import { getAgentProduct, getAffiliateLoginInfo } from '../store/actions/authActions';

const mapStatetoProps = (state) => ({
  distributorId: state.auth.distributorId,
  productArray: state.auth.productArray ?? [],
  redirect: state.auth.redirect,
  isAuthenticated: state.auth.isAuthenticated,
})

const LandingPageContainer = connect(mapStatetoProps, { getAgentProduct, getAffiliateLoginInfo
  })(({ toggleDrawer, ...props }) => (
    <LandingPage toggleDrawer={toggleDrawer} {...props}></LandingPage>
  ));
  
export default LandingPageContainer;
